
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.966 6.067a.7.7 0 01.99-.007l3.075 3.035 3.008-3.03a.7.7 0 11.993.987l-3.499 3.524a.7.7 0 01-.988.005L3.973 7.057a.7.7 0 01-.007-.99z","fill":"currentColor"}})])
          )
        }
      }
    